import { Box, Typography } from '@mui/material';
import React from 'react';

/**
 * Displays the active search query in a human-readable format.
 * In basic mode shows the plain text search; in JQL mode shows the query string
 * plus any advanced-search filter chips, the active date filter, and any client
 * addresses selected in the Packages by Address panel.
 */
export default function SearchQuerySummary({
  searchMode = 'basic',
  basicQuery = '',
  jqlQuery = '',
  filters = [],
  dateFilter = 'default',
  formatFieldLabel,
  addressLabels = [],
}) {
  const parts = [];

  if (searchMode === 'basic') {
    if (basicQuery.trim()) parts.push(`Search: "${basicQuery.trim()}"`);
  } else {
    if (jqlQuery.trim()) parts.push(jqlQuery.trim());
  }

  const filterQuery = filters
    .map((f) => `${formatFieldLabel ? formatFieldLabel(f.field) : f.field} = "${f.value}"`)
    .join(' AND ');
  if (filterQuery) parts.push(filterQuery);

  if (dateFilter !== 'default') parts.push(`Date = "${dateFilter}"`);

  // Selected client addresses OR together, and AND against everything else.
  if (addressLabels.length > 0) {
    parts.push(`Address in (${addressLabels.join(', ')})`);
  }

  if (parts.length === 0) return null;

  return (
    <Box mb={2}>
      <Typography variant="subtitle2" color="textSecondary">
        Current Search Query:
      </Typography>
      <Typography variant="body2" fontWeight="bold" sx={{ fontFamily: 'monospace' }}>
        {parts.join(' AND ')}
      </Typography>
    </Box>
  );
}
